@if (order.internalComment || order.customerComment ||order.comment) {
  <span nz-icon nzType="comment" nzTheme="outline" class="comment-icon" nz-tooltip [nzTooltipTitle]="customerComments"></span>
  <ng-template #customerComments let-thing>
    @if (order.customerComment) {
      <div>
        <b>Kundenkommentar</b><br>
        {{order.customerComment}}<br><br>
      </div>
    }
    @if (order.internalComment) {
      <div>
        <b>Interner Kommentar</b><br>
        {{order.internalComment}}<br><br>
      </div>
    }
    @if (order.comment) {
      <div>
        <b>Externer Kommentar</b><br>
        {{order.comment}}<br><br>
      </div>
    }
  </ng-template>
}

